<template>
  <div class="container">
    <div class="termsTitle">Cookie 使用政策</div>
    <div class="termsTitleSub">生效時間：2019 年 10 月</div>
    <div class="termsBox">
      <p>此 Cookie 通知適用揚揚創新科技有限公司（以下簡稱「本公司」）所擁有並營運之網站，包含但不限定於「Follow 音訊導覽服務平台https://followapp.y2services.com」，揚揚創新科技有限公司之官方網站，網址為https://www.y2services.com / http://www.yscreatech.com ，並詳述我們如何使用透過https://followapp.y2services.com （以下稱「網站」） 的 Cookies 和像素標籤等追蹤技術（以下稱「Cookies」）收集到的個人資料。</p>
    </div>
    <div class="termsBox">
      <div class="termsTitle">資料收集</div>
      <p>在您進入網站或瀏覽我們的精準廣告（targeted advertisement）時，我們就會用 Cookies 自動收集資料。</p>
      <p>我們會用 Cookies 收集的資料種類包括 IP 位址、註冊資料、裝置 ID、瀏覽頁面、瀏覽行為資訊、瀏覽器名稱、電腦作業系統、網路服務供應商、時間戳記、推薦連結 URL 以及因使用裝置而異的位置資料。</p>
      <p>更多 Cookies 相關資訊：Cookies 是網站發送至訪客瀏覽器的少量的數位資料，該資料會儲存在訪客的硬碟中。只要您造訪本站，我們就會在您的電腦上儲存 Cookies。如果您對裝置上存有 Cookies 有疑慮，您可以將瀏覽器設定為阻擋所有 Cookies，或是在儲存新 cookie 時顯示通知，讓您決定是否接受該 cookie。您也可以自行刪除裝置上的 Cookies。不過，如果您選擇阻擋或刪除 Cookies，網站上的特定功能可能會無法正常運作。</p>
      <p>更多像素標籤相關資訊：像素標籤（也稱作「網路臭蟲」或「透明影像圖檔」）是數位檔案，檔案內通常只有一個像素大小的一個影像，可以被嵌入網頁或是電子報等 Email 中來發送資訊。在您使用本站服務時，我們可能會使用像素標籤來放置或是辨認裝置上的 Cookie。</p>
      <p>第三方 Cookies：我們允許特定第三方放置 Cookies。如果您對我們使用哪些 Cookies 或是哪些第三方可以放置 Cookies 有疑問，請透過service@yscreatech.com 和我們聯繫。</p>
    </div>
    <div class="termsBox">
      <div class="termsTitle">使用目的</div>
      <p>本站透過 Cookies 收集您的資訊及個資的目的如下：</p>
      <div>
        <ul>
          <li>A. 提供本站服務：藉由透過 Cookies 收集的資料，您就能順利使用本站服務。此目的合乎本站的合法利益。</li>
          <li>B. 分析本站服務的使用情形：我們會使用透過 Cookies 收集的資訊分析訪客如何使用本站並產生相關報表。我們也會用 Cookies 來紀錄您在本站的使用行為，用以提升使用體驗及網站品質。此目的合乎本站的合法利益。</li>
          <li>C. 投放精準廣告：我們會使用透過 Cookies 收集的資訊來投放精準廣告，以獲得本站的合法利益。如有需要，我們會在放置此類 Cookies 前先徵求您的同意。即便您同意，您之後仍可隨時撤回。此外，您也可以隨時拒絕讓本站使用您的個人資料來投放廣告。</li>
          <li>D. 市場調查：我們會使用透過 Cookies 收集的資料來獲得合法利益，以進行市場調查（例如分析市場區隔或趨勢、偏好和行為，研究產品或服務，或行銷／廣告成效）或產品發展（例如為改善本站服務，分析市場區隔或客群的特性，或是本站績效表現。）</li>
        </ul>
      </div>
      <p>如欲阻擋上述 Cookies，且您無法自行完成相關設定（例如設定瀏覽器），請和 service@yscreatech.com 連絡。</p>
    </div>
    <div class="termsBox">
      <div class="termsTitle">分享資料</div>
      <p>和第三方分享：在法規許可範圍內，我們會按照下列方式和第三方（例如代表本站的服務供應商）分享您的個人資料。我們不會出售或出租您的個人資料。</p>
      <p>主管機關：我們將依據法律規定或出於預防、偵測、檢舉犯罪或詐騙行為之必要理由，向執法機關和其他政府單位提供您的個人資料。</p>
    </div>

    <div class="termsBox">
      <div class="termsTitle">資料保留期限</div>
      <p>Cookies 可分為工作階段 Cookies 和永久 Cookies。工作階段 Cookie 在瀏覽器關閉後即失效；永久 Cookie 壽命較長，且關閉瀏覽器後也不會自動刪除。我們儘量使用／允許使用壽命 5 年內的 Cookies ；只有在特殊情況下，例如基於安全目的（例如詐騙防治）及在絕對必要時，我們才會延長 Cookies 的壽命。如果您對特定資料保留期限有疑問，請透過下方所列連絡方式和我們聯繫。</p>
    </div>

    <div class="termsBox">
      <div class="termsTitle">問題或投訴</div>
      <p>如果您對於本站使用個人資料的方式有疑問或疑慮，或是您希望行使此通知所保障的權利，歡迎您和我們連絡： service@yscreatech.com。</p>
    </div>

    <div class="termsBox">
      <div class="termsTitle">通知內容更動</div>
      <p>由於本站業務內容時常變動，此 Cookie 通知內容也會因應調整。如果您之後想了解 Cookie 通知有哪些變更，歡迎您時常回來此頁面查看。</p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>
